import type { Cycle } from "../components/frozen-storage-data";

/**
 * Return the supporting files that still need to be uploaded or filed after
 * the specimen records themselves have been saved. A missing upload ID and a
 * missing document ID both represent a retryable attachment state.
 */
export function getUnfiledSpecimenAttachmentNames(
  cycles: readonly Cycle[] | null | undefined,
): string[] {
  const names = new Set<string>();

  for (const cycle of cycles ?? []) {
    for (const file of cycle.files) {
      if (!file.documentId) names.add(file.name);
    }
  }

  return [...names];
}
